import { useQuery } from "@tanstack/react-query";
import classNames from "classnames";
import { useRouter } from "next/router";

import { Size, WaitingListProduct } from "@/api/generatedTypes";
import WaitingListApi from "@/api/WaitingListApi";
import { useAuth } from "@/hooks/useAuth";
import { useToggle } from "@/hooks/useToggle";

import { useConfirm } from "../../ConfirmaitionHub/useConfirm";
import { BellIcon } from "../../icons/BellIcon";
import { PopupProductSizes } from "../../PopupProductSizes";
import { MainButton } from "../../ui-components/MainButton";
import styles from "./AddWaitingListButton.module.scss";

interface AddWaitingListButtonProps {
  isInWaitingList: boolean;
  sizes: Size[];
  addToWaitingList(sizeId: string): void;
  deleteFromWaitingList(waitingListId: number): void;
  sizesInWaitingList: WaitingListProduct[];
}

const AddWaitingListButton = ({
  isInWaitingList,
  sizes,
  addToWaitingList,
  deleteFromWaitingList,
  sizesInWaitingList,
}: AddWaitingListButtonProps) => {
  const {
    isOpen: isSizesPopupOpen,
    open: openSizesPopup,
    close: closeSizesPopup,
  } = useToggle();

  const confirm = useConfirm();
  const router = useRouter();

  const waitingListQuery = useQuery(
    ["waiting-list"],
    WaitingListApi.waitingList
  );
  const isAuthorized = useAuth();

  const waitingProducts = waitingListQuery.data?.data || [];
  const openMenuHandler = async () => {
    if (isAuthorized) return openSizesPopup();

    const isConfirm = await confirm({
      title: "сообщить, когда появится?",
      text: "Чтобы получить уведомление, когда товар будет доступен для заказа онлайн необходимо авторизоваться",
      submitText: "войти",
      cancelText: "отмена",
    });

    if (isConfirm) {
      window.localStorage.setItem("before_auth_url", router.asPath);
      router.push("/auth");
    }
    return;
  };

  const chooseSizeHandler = (size: Size) => () => {
    const sizeInWaitingList = sizesInWaitingList.find(
      (item) => item.size.id === size.id
    );
    if (sizeInWaitingList) {
      deleteFromWaitingList(sizeInWaitingList.id);
    } else {
      addToWaitingList(size.id);
    }
    closeSizesPopup();
  };

  const sizeAllAvailable = sizes.map((item) => ({
    ...item,
    count_online: 1,
  }));

  const choosenSizes = waitingProducts.map((item) => item.size);

  return (
    <div className={styles.root}>
      <MainButton
        className={classNames(styles.button, {
          [styles.filled]: isInWaitingList,
        })}
        onClick={openMenuHandler}
      >
        <BellIcon color={isInWaitingList ? "#EEEDEA" : "#928F8D"} />
      </MainButton>
      <PopupProductSizes
        isSizesPopupOpen={isSizesPopupOpen}
        closeSizesPopup={closeSizesPopup}
        sizes={sizeAllAvailable}
        chooseSizeHandler={chooseSizeHandler}
        sizesPopupClassName={styles.popup}
        choosenSize={choosenSizes}
      />
    </div>
  );
};

export default AddWaitingListButton;
